import React, { useCallback, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import requestChangeCardBlockerReason from 'store/sagas/requestChangeCardBlockerReason'
import requestChangeCardBlockerUser from 'store/sagas/requestChangeCardBlockerUser'
import { useDispatch, useSelector } from 'react-redux'
import { BlockerTypeField, UserField } from '../../../CardBlockerForm'
import { CardModalView, ViewBody } from 'components/Sidebar'
import { Formik } from 'formik'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  ButtonGroup,
} from 'react-bootstrap'
import Button from 'components/Button'
import styled from 'styled-components'
import { ModalCardContext } from 'components/Modal'
import UnblockCard from './UnblockCard'
import { useCardContext } from 'dataProviders/Card'

const UnblockButton = styled(Button)`
  margin-left: 1em;
`

type Props = LeftSidebarProps & {
  cardBlockerId: number;
}

const EditCardBlocker: React.FC<Props> = ({
  leftSidebar,
  cardBlockerId,
}) => {
  const cardContext = useCardContext()

  const dispatch = useDispatch()

  const cardBlocker = useSelector<any, any>(state => state.kanbo.cardBlockers.byId[cardBlockerId])
  
  const close = useCallback(() => {
    leftSidebar.pop()
  }, [])

  useEffect(() => {
    if (!cardBlocker) {
      close()
    }
  }, [cardBlocker])

  return (
    <CardModalView
      title={<FormattedMessage id='BLOCKERS_CARD_BLOCK_EDIT' />}
    >
      {cardBlocker &&
        <Formik
          initialValues={{
            blockerId: cardBlocker.blockerId,
            userId: cardBlocker.userId,
            reason: cardBlocker.reason,
          }}
          onSubmit={({ reason, userId }) => {
            if (reason !== cardBlocker.reason) {
              dispatch(requestChangeCardBlockerReason({
                cardBlockerId,
                reason,
              }))
            }

            if (userId !== cardBlocker.userId) {
              dispatch(requestChangeCardBlockerUser({
                cardBlockerId,
                userId: userId || null,
              }))
            }

            close()
          }}
        >
          {formik =>
            <form onSubmit={formik.handleSubmit}>
              <BlockerTypeField
                disabled
                name='blockerId'
              />
              <UserField
                name='userId'
              />
              <ViewBody>
                <FormGroup>
                  <ControlLabel><FormattedMessage id='BLOCKERS_CARD_BLOCK_REASON' /></ControlLabel>
                  <FormattedMessage id='BLOCKERS_CARD_BLOCK_REASON_PLACEHOLDER'>
                    {formattedMessage =>
                      <FormControl
                        type='text'
                        name='reason'
                        value={formik.values.reason}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder={formattedMessage}
                      />
                    }
                  </FormattedMessage>
                </FormGroup>
                <ButtonGroup>
                  <Button type='submit' bsStyle='primary' disabled={formik.isSubmitting}>
                    <FormattedMessage id='SAVE' />
                  </Button>
                  <Button onClick={close}><FormattedMessage id='CANCEL' /></Button>
                </ButtonGroup>
                <UnblockButton
                  bsStyle='primary'
                  onClick={() => {
                    leftSidebar.push(() => <ModalCardContext cardId={cardContext.id}><UnblockCard cardBlockerId={cardBlocker.id} /></ModalCardContext>)
                  }}
                >
                  <FormattedMessage id='BLOCKERS_CARD_UNBLOCK' />
                </UnblockButton>
              </ViewBody>
            </form>
          }
        </Formik>
      }
    </CardModalView>
  )
}

export default withLeftSidebar(EditCardBlocker)
